module.exports = __webpack_public_path__ + "static/media/saveIcon.fa5f5453.svg";